'use client';

import { type ButtonProps } from '@curology/ui-components-web/react';
import clsx from 'clsx';

import { Button } from '@/components/squeeze';

/**
 * This component is a little complex around the loading/disabled states, so here's a breakdown:
 *
 * When the button is clicked, it will set both a local `loading` state and a global `navigating` state.
 * - The local `loading` state is used to show the loading spinner on the button.
 * - The global `navigating` state is used to disable all other navigation buttons on the page
 * while the page is navigating.
 *
 * The above behaviors can be overridden by passing in `loading` and `disabled` props.
 */
export const ProgressButton = ({
  buttonType,
  ...props
}: Omit<ButtonProps, 'formAction'>) => (
  <Button
    buttonType={buttonType}
    className={clsx(
      'cur-w-full',
      buttonType === 'text' ? 'cur-text-primary' : undefined,
    )}
    {...props}
  />
);
